<template>
  <div>
    <sweet-modal style="z-index: 10001" :title="$t('ct-add-icon-title')" ref="modal" width="70vw">
      <div class="text-icons-input-container input-group mb-3">
        <select v-model="selectedLibraryName" class="mr-1 ba-select">
          <option value="material">Material icons</option>
          <!-- 
          <option value="faSolid">Font Awesome Solid</option>
          <option value="faRegular">Font Awesome Regular</option>
          -->
          <option value="faBrands">Font Awesome Brands</option>
        </select>
        <div class="input-group-prepend">
          <span class="input-group-text"><font-awesome-icon icon="search"/></span>
        </div>
        <input type="text" class="form-control" :placeholder="$t('ct-search')" v-model="filter">
      </div>

      <div class="text-icons-container" ref="text-icons-container" v-if="true">
        <div v-for="(element,index) in iconsList" :key="element" class="item-icon show" :data-name="element">
          <i
            :class="[element, {focused: element == iconSelected}]"
            @click="selectIcon(element)"
            :value="element">
          </i>
        </div>
        <div v-show="showColor">ShowColor</div>
      </div>
      <div class="text-icons-container" v-else-if="!loading && iconsList.length === 0">
        <p class="mb-0 text-center">{{ $t('ct-icon-not-found')}}</p>
      </div>

      <div class="text-icons-container" v-else>
        <div class="text-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>

      <button slot="button" class="btn btn-outline-light" @click="close">{{ $t('ct-cancel') }}</button>
      <button slot="button" class="btn btn-success" @click="save"><i class="svg-icon svgi-save"></i>{{ $t('ct-select') }}</button>
    </sweet-modal>
  </div>
</template>
<script>

import IconList from './Abstract/IconList';
import {SweetModal} from 'sweet-modal-vue';

export default {
  name: 'TextIconComponent',
  components: {
    IconList,
    SweetModal
  },
  data() {
    return {
      element: null,
      value: '',
      labelDesc: 'opa',
      callback: null,
      showColor: false,
      filter: '',
      iconSelected: '',
      position: '',
      iconsList: [],
      iconsListGroups: IconList.data(),
      selectedLibraryName: undefined,
      loading: false
    };
  },

  watch: {
    selectedLibraryName() {
      this.iconsList = JSON.parse(JSON.stringify(this.iconsListGroups[this.selectedLibraryName]))
      if (this.filter) this.filterSelection()
    },
    filter() {
      this.filterSelection()
    }
  },

  methods: {

    save() {
      this.callback(this.iconSelected, '#000');
      this.$refs.modal.close();
      this.$root.$emit('blurEvent', true);
    },

    close() {
      this.iconSelected = '';
      this.$refs.modal.close();
      this.$root.$emit('blurEvent', true);
    },

    selectIcon(icon) {
      this.iconSelected = icon;
    },

    filterSelection() {
      let c = this.filter.toLowerCase().trim();
      this.iconsList = JSON.parse(JSON.stringify(
        this.iconsListGroups[this.selectedLibraryName].filter(
          icon => icon.indexOf(c) > -1
        )
      ))
    },
    showIconList() {
      let vm = this;
      this.loading = true;

      this.filter = '';
      this.iconSelected = ''
      this.selectedLibraryName = 'material'
      console.log(this.$refs.modal)
      this.$refs.modal.open();

      setTimeout(function() {
        vm.loading = false;
      }, 500);
    }
  },
  mounted() {
    let vm = this;
    console.log('montouuu')
    this.$root.$on('showIconList', (callback, showColor) => {
      vm.showColor = showColor;
      vm.callback = callback;
      vm.showIconList();
    });
  }
};
</script>
<style scoped lang="scss">
  .form-group {
    overflow: hidden;
  }
  .ba-select {
    color: #8d9eb5;
    background-color: #f4f6fb;
    border: none;
    border-radius: 6px;
    outline: none;
    min-height: 35px;
    padding: 6.4px 12.8px;
    font-size: 12.8px;
    font-weight: 600;
  }
</style>
<style lang="scss">
  .item-icon {
    display: none;
    width: 40px;
    height: 40px;
    font-size: 30px;
    cursor: pointer;

    .focused {
      border-radius: 5px;
      color: #FFF;
      background-color: #0080FC;
    }

    .mdi {
      width: 40px;
      height: 40px;
      text-align: center;
    }
  }

  .text-icons-input-container {
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    border-radius: 3px;
    height: 46px;

    .input-group-append {
      .btn {
        height: 100%;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        box-shadow: none;

        font-size: 13px;
        font-weight: bold;
        font-family: "Muli", "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif;
      }
    }

    .input-group-text {
      margin-left: 5px;

      background: none;
      border: none;
      color: #A8A8A8;
    }

    input {
      height: 40px;
      border: none;
      margin-top: 3px;

      font: normal normal normal 14px Lato;
      color: #656565;
    }
  }

  .text-icons-container {
    padding: 20px;
    max-height: 50vh;
    overflow: auto;
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    border-radius: 3px;

    .item-icon {
      margin-left: 3px;
      margin-right: 3px;

      &.show {
        display: inline-flex;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/resources/TextIcon.vue